module.exports = __webpack_public_path__ + "static/media/rocket.beea1d7b.svg";